import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/vercel/path0/layouts/admin.vue").then(m => m.default || m)),
  dashboard: defineAsyncComponent(() => import("/vercel/path0/layouts/dashboard.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  odeme: defineAsyncComponent(() => import("/vercel/path0/layouts/odeme.vue").then(m => m.default || m))
}